import { useQuery, useQueryClient } from "@tanstack/react-query";
import { ShieldAlert } from "lucide-react";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { api, errorMessage, fmtDate } from "@/lib/api";

export const BlockedIps = () => {
  const qc = useQueryClient();
  const { data: blocks = [] } = useQuery({ queryKey: ["ip-blocks"], queryFn: () => api.get("/admin/ip-blocks").then((r) => r.data), refetchInterval: 60000 });
  const unblock = async (ip) => {
    try { await api.delete(`/admin/ip-blocks/${encodeURIComponent(ip)}`); toast.success(`Unblocked ${ip}`); qc.invalidateQueries({ queryKey: ["ip-blocks"] }); }
    catch (e) { toast.error(errorMessage(e)); }
  };
  return (
    <div data-testid="blocked-ips-card" className="bg-[#0F172A] border border-slate-800 rounded-xl p-5 rise" style={{ animationDelay: "160ms" }}>
      <div className="flex items-center gap-2">
        <ShieldAlert className="h-4 w-4 text-amber-400" />
        <h2 className="font-heading text-lg font-semibold">Blocked IPs</h2>
      </div>
      <p className="text-xs text-slate-500 mt-1">An IP that sends 10 invalid keys within 10 minutes is blocked for 30 minutes.</p>
      {blocks.length ? (
        <ul className="mt-4 divide-y divide-slate-800">
          {blocks.map((b) => (
            <li key={b.ip} data-testid="blocked-ip-row" className="py-3 flex items-center justify-between gap-3">
              <div className="min-w-0">
                <p className="font-mono text-sm text-slate-100">{b.ip}</p>
                <p className="text-xs text-slate-500">{b.reason} · until {fmtDate(b.expires_at)}</p>
              </div>
              <Button data-testid="unblock-ip-button" size="sm" variant="outline" onClick={() => unblock(b.ip)} className="border-slate-700 bg-transparent text-slate-200 hover:bg-slate-800 hover:text-white">Unblock</Button>
            </li>
          ))}
        </ul>
      ) : <p data-testid="blocked-ips-empty" className="mt-4 text-sm text-slate-500">No IPs blocked right now.</p>}
    </div>
  );
};
